import { Layout } from 'antd';
import dayjs from 'dayjs';

const { Footer } = Layout;
const CustomOrderFooter = () => {
  return (
    <Footer style={{ textAlign: 'center' }}>
      MyDelivery System ©{dayjs().format('YYYY')} Created by MongolPost
    </Footer>
  );
};

export default CustomOrderFooter;
